import request from '@/utils/request';
export function getAsyncRoutes(data) {
  return request({
    url: '/rbac/permissions/menu',
    method: 'get',
    data: data
  });
}